
/*
 *
 * Date: 2025
 * Description: Logs page to see api interactions logs
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Grid,  Typography } from "@mui/material"
import { ReactElement, JSX, useEffect, useState, Fragment , useContext } from "react"

//Interfaces
import { i_logs } from "../interfaces/items.interface"
import { i_filter } from "../interfaces/utility.interface"

//Constants
import { default_search } from "../utils/constant"
import { handleFetch } from "../api/fetch"

//Styles
import { box_border, title_tbl } from "../styles/main"

//Components
import Footer from "../components/utils/footer"
import { formatTimestamp } from "../utils/utility"
import { useNavigate } from "react-router-dom"

//Context
import { MainContext } from "../context/context"

//Utilities

const Logs = ( )  :  JSX.Element | ReactElement => {
    const { HandleLogout } = useContext(MainContext)
    const [ loading , setLoading ] = useState<boolean>(false)
    const [ logs , setLogs ] = useState<i_logs[]>([])
    const [ count , setCount ] = useState<number>(0)
    const [ filter , setFilter ] = useState<i_filter>(default_search)
    const nav = useNavigate()
    useEffect(() => {
        const getLogs = async() => {
            setLoading(true)
            const res = await handleFetch('/logs' , 'GET' , true , null)
            if(res.type === 'Success'){
                setLoading(false)
                setLogs(res.data.logs)
                setCount(res.data.count)
            }
            if(res.type === 'Unauthorized'){
                HandleLogout(nav)
            }
            setLoading(false)
        }
        getLogs()
    },[filter])
    return (
        <Box>
            <Box sx={{height : '100%' }}>
                <Grid container sx={{maxWidth : 1200 , marginLeft : 'auto' , marginRight : 'auto' , alignItems : 'center' }}>
                    <Grid size={{ xs:12}} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fonSize : 24 , fontWeight : 800 , marginTop : '2vh'}}>Logs debug page</Typography>
                    </Grid>
                    <Grid size={{ xs : 4}} >
                        <Box sx={box_border}>
                        <Typography sx={title_tbl}>Description</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs : 2}}>
                        <Box sx={box_border}>
                        <Typography sx={title_tbl}>Event</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs : 2}}>
                        <Box sx={box_border}>
                        <Typography sx={title_tbl}>Subject</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs : 2}}>
                        <Box sx={box_border}>
                            <Typography sx={title_tbl}>Type</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs : 2}}>
                        <Box sx={box_border}>
                            <Typography sx={title_tbl}>Date</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container  sx={{maxWidth : 1200 , marginLeft : 'auto' , marginRight : 'auto' , alignItems : 'center' , overflowY : 'auto', maxHeight : '75vh' }}>
                    {logs.map(( log : i_logs , index : number) => (
                        <Fragment key={index}>
                        <Grid size={{ xs : 4}} >
                           <Box sx={box_border}>
                           <Typography sx={title_tbl}>{log.description === '' ? "No description" : log.description}</Typography>
                           </Box>
                       </Grid>
                       <Grid size={{ xs : 2}}>
                           <Box sx={box_border}>
                           <Typography sx={title_tbl}>{log.event}</Typography>
                           </Box>
                       </Grid>
                       <Grid size={{ xs : 2}}>
                           <Box sx={box_border}>
                           <Typography sx={title_tbl}>{log.subject}</Typography>
                           </Box>
                       </Grid>
                       <Grid size={{ xs : 2}}>
                           <Box sx={box_border}>
                               <Typography sx={title_tbl}>{log.type}</Typography>
                           </Box>
                       </Grid>
                       <Grid size={{ xs : 2}}>
                           <Box sx={box_border}>
                               <Typography sx={title_tbl}>{formatTimestamp(log.timestamp)}</Typography>
                           </Box>
                       </Grid>
                       </Fragment>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}


export default Logs;